import { css } from '@emotion/css'
import { borderRadius, spacing, fontFamily, fontSize, fontWeight } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { accessiblyHidden } from '../../utils/styleUtils'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    lineHeight: 1.2,
    fontWeight: fontWeight.semiBold,
    borderRadius: borderRadius.default,
    padding: shorthandHelper([0, spacing.default]),
  }),

  icon: css({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    borderWidth: 0,
    padding: 0,
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)

  // Light theme is a bit of a special case
  if (theme === 'light') {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo,
    })
  }

  return css({
    backgroundColor: themed.light,
    color: themed.base,
  })
}

export const hoverTheme = theme => {
  const themed = getThemeColors(theme)

  // Light theme is a bit of a special case
  if (theme === 'light') {
    return css({
      '&:hover': {
        backgroundColor: themed.medium,
        color: colors.jumbo,
      },
    })
  }

  return css({
    '&:hover': {
      backgroundColor: themed.base,
      color: colors.white,

      '& svg path': {
        fill: colors.white,
      },
    },
  })
}

export const iconTheme = theme => {
  // Light theme is a special case
  if (theme === 'light') return colors.jumbo

  const themed = getThemeColors(theme)
  return themed.base
}

export const wrapperSize = size => {
  switch (size) {
    case 'small':
      return css({
        height: 30,
      })

    default:
      return css({
        height: 35,
      })
  }
}

export const iconSize = size => {
  switch (size) {
    case 'small':
      return 16

    default:
      return 18
  }
}

export const iconWrapperSize = size => {
  switch (size) {
    case 'small':
      return css({
        marginLeft: spacing.small,
      })

    default:
      return css({
        marginLeft: spacing.default,
      })
  }
}
